import React from 'react'
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  renderFieldMonetarioLabelEncima, renderFieldNumeros, renderFieldPercentual, renderFieldText, required
} from '../../util/inputs'
import adicionarNotaFiscal from '../../actions/encomenda/adicionarNotaFiscal';

export class FormCadastroNotaFiscal extends React.Component {

  submit(values) {
    this.props.adicionarNotaFiscal({ ...values, ordem: this.props.notasFiscais.length });
  }

  render() {
    const {
      handleSubmit, submitting, invalid, pristine
    } = this.props;
    return (      
      <div>
        <form onSubmit={handleSubmit(this.submit.bind(this))}>
        <fieldset className="scheduler-border">
          <legend className="scheduler-border">Cadastro de Nota Fiscal</legend>
          <div className="form-row">
            <div className="col-12 col-sm-3 col-md-3">
              <Field name="numeroDocumento" type="text" validate={[required]} required={true} component={renderFieldText} label="Número documento:"
                css="form-control" />
            </div>
            <div className="col-12 col-sm-3 col-md-3">
              <Field name='valor' validate={[required]} component={renderFieldMonetarioLabelEncima} className="form-control" label="Valor" />
            </div>
            <div className="col-12 col-sm-3 col-md-3">
              <Field name='volume' css="form-control" validate={[required]} component={renderFieldNumeros} label="Volume" />
            </div>
            <div className="col-12 col-sm-3 col-md-3">
              <Field name='peso' validate={[required]} component={renderFieldPercentual} className="form-control" label="Peso" />
            </div>
            <div className="modal-footer mt-4">              
              <button type="submit" disabled={invalid || submitting || pristine}
                className="btn btn-laranja">Adicionar
              </button>
            </div>
          </div>
        </fieldset>
        </form>
      </div>
    );
  }
}

export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    adicionarNotaFiscal
  }, dispatch)
);

export const mapStateToProps = state => (
  {
    notasFiscais: state.dadosPagamentoEncomenda.notasFiscais,
    initialValues: {
      valor: '0',
      peso: '0',
      volume: '0',
      numeroDocumento: ''
    }
  });

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: 'formularioCadastroNotaFiscal',
  enableReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(FormCadastroNotaFiscal));
